import * as React from 'react';
import { useDataGridRow_unstable } from './useDataGridRow';
import { renderDataGridRow_unstable } from './renderDataGridRow';
import { useDataGridRowStyles_unstable } from './useDataGridRowStyles.styles';
import { useCustomStyleHook_unstable } from '@fluentui/react-shared-contexts';
/**
 * DataGridRow component
 */ export const DataGridRow = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useDataGridRow_unstable(props, ref);
    useDataGridRowStyles_unstable(state);
    useCustomStyleHook_unstable('useDataGridRowStyles_unstable')(state);
    return renderDataGridRow_unstable(state);
});
DataGridRow.displayName = 'DataGridRow';
